/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
	resource_id: string;
	resource_type: string;
}

interface ResourceData {
	id: number;
	id_prefix_value: number;
	resource_id: string;
	file_name: string;
	file_duration: string;
	url: string;
	transcoding_url: string;
	transcoding_ext: string;
	thumb_info: string[];
	vod_file_id: string;
	vod_transcoding_url: string;
	status: string;
	is_recycle: number;
	is_deleted: number;
	regular_deleted_by_eid: number;
	is_live: number;
	live_session_status: string;
	create_time: number;
	resource_type: number;
  }

interface IOutput {
	resource_data: ResourceData;
}

export const getResourceInfo = (data: IInput): Promise<IResponse<IOutput>> => {
	return fetchData(Api.GET_RESOURCE_INFO, data).then((res: IResponse<IOutput>) => {
		return res;
	});
};

export const getResourceInfoSync = fetchDataSync(getResourceInfo);
